var dermpathSlide = function(global) {
    // clear it out
    var frame = $(global.dermpath).find('.image-column .image-frame');
    frame.html('');
    var rightColumn = $(global.dermpath).find('.image-column-right');
    rightColumn.html('');

    var slide = global.dermpaths[global.currentSlide];


    var str = '<img class="slide-image" src="'+ slide.images[0].src+'" />';
    var image = $.parseHTML(str);
    frame.append(image);

    var rightStr = '<ul class="dermpath-images">';
    _(slide.images).each(function(row) {
        rightStr += '<li><img src="'+ row.src +'" /><br />'+row.label+'</li>'
    });
    rightStr += '</ul>';
    rightColumn.append($.parseHTML(rightStr));

    rightColumn.find('.dermpath-images li img').click(function() {
        $(image).attr('src',this.src);
    });

    $(global.dermpath).find('.diagnosis span').html(slide.name);

}


module.exports = dermpathSlide;


//////////////////
// WEBPACK FOOTER
// ./src/dermpath_slide.js
// module id = 305
// module chunks = 0